import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { FreeAssessment } from './pages/FreeAssessment';
import { HireUs } from './pages/HireUs';
export function AppRouter() {
  return <BrowserRouter data-id="element-13">
      <Routes data-id="element-14">
        <Route path="/" element={<App data-id="element-16" />} data-id="element-15" />
        <Route path="/free-assessment" element={<FreeAssessment data-id="element-18" />} data-id="element-17" />
        <Route path="/hire-us" element={<HireUs data-id="element-20" />} data-id="element-19" />
      </Routes>
    </BrowserRouter>;
}